import { useSelector } from 'react-redux';

import { QueryBuilderIndex } from '../../types';
import { useCatalogFieldFacets } from './useCatalogFieldFacets';
import { useListFieldFacets } from './useListFieldFacets';
import { selectEsIndex } from '../../selectors';
import { useFieldFacetsErrorToast } from './useFieldFacetsErrorToast';
import { useIsGeoLocationFieldType } from '../useIsGeoLocationFieldType';

export const useFieldFacets = () => {
  const esIndex = useSelector(selectEsIndex);
  const isGeoLocationFieldType = useIsGeoLocationFieldType();
  const listResults = useListFieldFacets(
    esIndex === QueryBuilderIndex.UserAndEvent && !isGeoLocationFieldType,
  );
  const catalogResults = useCatalogFieldFacets(
    esIndex === QueryBuilderIndex.Catalog && !isGeoLocationFieldType,
  );

  const error = listResults.error || catalogResults.error;
  useFieldFacetsErrorToast(!!error);

  const isLoading = listResults.isLoading || catalogResults.isLoading;
  const { facets } = esIndex === QueryBuilderIndex.UserAndEvent ? listResults : catalogResults;
  return { isLoading, facets };
};
